import { CheckboxAgreement } from '@/shared/components'

type ApplicationConsentSectionProps = {
  checked: boolean
  disabled?: boolean
  error?: string
  onChange: (value: boolean) => void
}

export function ApplicationConsentSection({
  checked,
  disabled = false,
  error,
  onChange
}: ApplicationConsentSectionProps) {
  return (
    <div className="mt-6 space-y-1">
      <CheckboxAgreement checked={checked} disabled={disabled} onChange={onChange} />
      {error ? <p className="mt-1 text-center text-xs text-red-500">{error}</p> : null}
    </div>
  )
}
